exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-new-document-extract-financial-component .upload{width:100%}.modal-new-document-extract-financial-component .upload .upload-draggable{width:100%}", ""]);

// exports
